(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-cta-button"] && !Shopify.designMode) return;
  try {
    // Already on the page the button links to (the product page): scroll to the buy box instead of reloading
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-header-cta]');
    if (!link || link.target === '_blank' || new URL(link.href, location.href).pathname !== location.pathname) return;
    const buyBox = document.querySelector('.purchase-selector');
    if (!buyBox) return;
    event.preventDefault();
    const header = document.querySelector('#header-component, .header');
    buyBox.style.scrollMarginTop = `${(header?.offsetHeight || 0) + 16}px`;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    buyBox.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ingredients-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ingredients-drawer')) {
    customElements.define(
      'ingredients-drawer',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.onOpenClick = (event) => {
            const trigger = event.target.closest(`[data-ingredients-drawer-open="${this.dialog.id}"]`);
            if (!trigger) return;
            event.preventDefault();
            this.lastTrigger = trigger;
            this.dialog.showModal();
            document.documentElement.style.overflow = 'hidden';
          };
          document.addEventListener('click', this.onOpenClick);

          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog && !event.target.closest('.ingredients-drawer__panel')) this.close();
            if (event.target.closest('[data-ingredients-drawer-close], .ingredients-drawer__body a[href]')) this.close();
          });
          this.dialog.addEventListener('cancel', (event) => {
            event.preventDefault();
            this.close();
          });
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.onOpenClick);
        }

        close() {
          this.dialog.classList.add('is-closing');
          const done = () => {
            this.dialog.classList.remove('is-closing');
            this.dialog.close();
            document.documentElement.style.overflow = '';
            this.lastTrigger?.focus();
          };
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          reduce ? done() : setTimeout(done, 250);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
